
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoshrivardhancab() {



    const cardData =
    {
        keyword: 'Pune to Shrivardhan Cab',
        heading: 'Meghana Cab : Pune to Shrivardhan Cab',
        headingDescription: 'Meghana Cab offers Pune to Shrivardhan Cab services, providing a scenic, comfortable, and reliable travel experience along the picturesque Konkan coastline. Covering approximately 160 kilometers, the journey from Pune to Shrivardhan takes you through winding ghats, lush greenery, and coastal villages, made more enjoyable in our well-maintained AC sedans, SUVs, and tempo travellers. Whether you’re planning a weekend beach getaway, family vacation, or spiritual visit to the Suvarnaganesh Temple, our professional drivers ensure safety, punctuality, and comfort throughout the trip. With 24×7 customer support, affordable fares, and easy booking options, Meghana Cab makes your Pune to Shrivardhan journey relaxed, memorable, and worry-free.',


        top: 'Top Places to Visit in Shrivardhan with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a majestic palace-fort in the heart of Pune, originally built in 1730 AD by the Peshwas. Its grand gates, ornate balconies, and spacious courtyards reflect the glory of Maratha architecture. Though much was destroyed by fire, the remaining ruins echo tales of intrigue, power, and royal life. Evening light-and-sound shows narrate its history, drawing locals and tourists alike. The gardens and pathways are perfect for leisurely strolls. Close to Dagdusheth Ganapati, it anchors the city’s old-town heritage precinct."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a serene, sprawling memorial where Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters were interned during India’s Quit India Movement. Its graceful domes, imposing pillars, and lush gardens offer a peaceful retreat. The small museum inside displays letters, photographs, and personal items of Gandhi, making it both spiritual and educational. The garden's paths and fountains invite reflective walks. It also symbolizes Pune’s role in India’s struggle for independence."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Embedded in the city’s core, Pataleshwar is an 8th-century rock-cut cave temple first carved during the Rashtrakuta era. Though modest in scale, its monolithic excavation, pillared hall, and Nandi shrine convey an aura of ancient artistry and devotion. It’s surprising to find such calm in bustling Pune. The surrounding garden and shaded areas make it a quiet retreat. Photography is limited inside, ensuring the sanctity of this sacred site. A visit here connects city walkers to Pune’s hidden historic soul."
  },
  {
    "title": "Pune-Okayama Friendship Garden (Pu La Deshpande Garden)",
    "description": "Also called the Pu La Deshpande Udyan, this garden is Pune’s Japanese-style oasis inspired by Okayama’s Koraku-en Garden. Spread across 10 acres, the garden features meandering walkways, gently flowing water canals, stone bridges, koi ponds, and manicured landscaping. It’s an ideal spot for morning walks, poetry reading, or quiet meditation. The balance of water, stone, and green spaces makes it especially soothing during monsoons. Locals often visit for picnics and family time."
  },
  {
    "title": "ISKCON NVCC Temple",
    "description": "ISKCON NVCC (New Vedic Cultural Center) is a beautiful temple complex located in Kondhwa, Pune, dedicated to Radha-Krishna and Venkateswara (Balaji). Built with red sandstone, marble, and intricate carvings, its architecture blends North and South styles. The temple hosts daily kirtans, Gita classes, and spiritual discourses. The sacred ambiance, pristine gardens, and calm prayer halls invite visitors seeking peace and devotion. It’s also a spiritual landmark amidst Pune’s urban sprawl."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched about 25 km southwest of Pune, Sinhagad is a legendary hill fort with dramatic views over the surrounding valleys. The trek to the fort is famed—especially during monsoon—through lush greenery and rugged terrain. At the top, ruins of bastions, gates, and water tanks await exploration. The fort witnessed heroic battles (e.g. Tanaji’s sacrifice) and still resonates with tales of Maratha valor. Early morning visits reward you with sunrise, fresh mountain air, and quiet reflections far from the city bustle."
  },
  {
    "title": "Karla and Bhaja Caves",
    "description": "On the outskirts of Pune lie the ancient Buddhist rock-cut caves of Karla and Bhaja, dating back over 2,000 years. Karla has one of India’s largest chaityas (prayer halls), while Bhaja features intricate carvings, stupas, and dancing figures. The approach involves a short nature walk, passing scenic hills and greenery. The caves reflect India’s early Buddhist heritage and artistic brilliance. They’re ideal for history buffs, spiritual seekers, and nature lovers alike—blending culture with tranquility."
  },
  {
    "title": "Tikona Fort",
    "description": "Situated about 60 km from Pune in Maval, Tikona Fort (also called Vitandgad) is a pyramidal hill fort ideal for trekking and panoramic views. The ascent leads you past seven natural water tanks, remains of old stone gates, and ASI-protected ruins. At the top, you get sweeping vistas of Pawna reservoir, nearby forts like Lohagad and Visapur, and rolling hills. It’s a moderately challenging but rewarding hike, especially enjoyed during monsoon when the hills are lush and misty."
  },
  {
    "title": "Bal Gandharva Ranga Mandir",
    "description": "Bal Gandharva Ranga Mandir is a prominent cultural theatre in Shivajinagar, Pune, named after the famous Marathi singer-actor Bal Gandharva. With a seating capacity of nearly 1,000, it hosts regular Marathi and Hindi plays, musicals, exhibitions, and cultural events. The building also has an exhibition hall showcasing theatre memorabilia. Visiting a performance here offers immersive insight into Pune’s vibrant performing arts scene. Even the surroundings—tree-lined streets, street cafés—echo local life and artistry."
  },
  {
    "title": "Vishrambaug Wada & Lal Mahal",
    "description": "Vishrambaug Wada and Lal Mahal are heritage mansions hidden within Pune’s wadas (old quarters). Wadas were traditional townhouses of Maratha nobility. Vishrambaug Wada still has intricately carved wooden balconies, internal courtyards, and a sense of the bygone era. Near it lies Lal Mahal, once home to Shivaji Maharaj as a young prince. Though much of Lal Mahal is reconstructed, it houses a small museum and replicates Maratha-era life. Exploring these gives you a walking-tour feel of old Pune’s lanes, stories, and royal past."
  }
],

          "services": [
    {
      "name": "Pune to Shrivardhan Cab Booking",
      "description": "Book a comfortable cab from Pune to Shrivardhan with Meghana Cab for a hassle-free coastal trip. Our cabs offer spacious seating, air conditioning, and experienced drivers who know the best routes to make your journey smooth and enjoyable. Ideal for family vacations, weekend getaways, and beach trips, our Pune to Shrivardhan cab booking service provides flexible packages and competitive pricing."
    },
    {
      "name": "Pune to Shrivardhan Innova Crysta",
      "description": "Travel in luxury and comfort with our Pune to Shrivardhan Innova Crysta service. Perfect for families and groups who want extra space and premium amenities, the Innova Crysta features plush interiors, ample luggage capacity, and air conditioning. Enjoy a scenic and relaxed ride along the Konkan coast with Meghana Cab’s reliable and punctual service."
    },
    {
      "name": "Pune to Shrivardhan Ertiga Car Booking",
      "description": "Opt for the spacious and economical Ertiga car from Pune to Shrivardhan. Ideal for small groups and families, our Ertiga rentals offer comfort, fuel efficiency, and smooth rides. Our well-maintained cars and professional drivers ensure a safe and pleasant trip to the beautiful beaches of Shrivardhan."
    },
    {
      "name": "Pune to Shrivardhan Beach Cab",
      "description": "Make your trip to Shrivardhan beach relaxing with Meghana Cab’s dedicated beach cab service. Experience door-to-door pickup, clean vehicles, and courteous drivers who prioritize your comfort. Our service is perfect for beach lovers looking to escape the city and enjoy the serene Konkan coast."
    },
    {
      "name": "Pune to Shrivardhan Beach Cab Fare",
      "description": "Get transparent and competitive fare estimates for your Pune to Shrivardhan beach cab journey. Meghana Cab offers cost-effective packages with no hidden charges, ensuring you get the best value for your money while enjoying a comfortable ride. Contact us for custom fare quotes tailored to your travel dates and vehicle preferences."
    },
    {
      "name": "Pune to Harihareshwar Cab Booking",
      "description": "Plan your spiritual and scenic trip from Pune to Harihareshwar with Meghana Cab. Our cabs provide a comfortable ride to this serene beach and temple destination, with flexible booking options and a choice of vehicles including Innova Crysta and Ertiga. Experience safe travel with our professional drivers and timely service."
    },
    {
      "name": "Pune to Ganpatipule Cabs",
      "description": "Travel from Pune to the famous Ganpatipule temple and beach with Meghana Cab’s reliable cab services. Whether for pilgrimage or leisure, our spacious vehicles and expert drivers ensure a smooth journey through the Konkan region. Choose from a variety of cars including SUVs and sedans for your Ganpatipule trip."
    },
    {
      "name": "Pune to Konkan Innova Cab",
      "description": "Explore the beautiful Konkan coastline with Meghana Cab’s Innova cab service from Pune. Our premium Innova vehicles offer comfort, space, and safety for your coastal adventures. Whether you’re visiting Shrivardhan, Ganpatipule, or Harihareshwar, enjoy a smooth ride with our experienced drivers."
    },
    {
      "name": "Pune to Mahabaleshwar Innova Rate",
      "description": "Check affordable and transparent Innova cab rates for your Pune to Mahabaleshwar trip with Meghana Cab. Our pricing offers great value without compromising on comfort or service quality. Book your Innova cab today for a scenic hill station getaway."
    },
    {
      "name": "Pune to Sawantwadi Cab",
      "description": "Book a safe and comfortable cab from Pune to Sawantwadi with Meghana Cab. Our vehicles are perfect for long-distance travel with spacious interiors and reliable drivers. Whether for business or leisure, our Pune to Sawantwadi cab service ensures a timely and pleasant journey."
    },
    {
      "name": "Pune to Ratnagiri Cab Price",
      "description": "Get competitive cab pricing for your Pune to Ratnagiri journey with Meghana Cab. We offer transparent and budget-friendly fares for various vehicle types, including sedans and SUVs, ensuring you have a comfortable and affordable trip along the Konkan coast."
    }
  ],
  "tableData": [
    ["Pune to Shrivardhan Cab Booking", "Pune to Shrivardhan Innova Crysta"],
    ["Pune to Shrivardhan Ertiga Car Booking", "Pune to Shrivardhan Beach Cab"],
    ["Pune to Harihareshwar Cab Booking", "Pune to Ganpatipule Cabs"],
    ["Pune to Konkan Innova Cab", "Pune to Mahabaleshwar Innova Rate"],
    ["Pune to Sawantwadi Cab", "Pune to Ratnagiri Cab Price"]
  ],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Shrivardhan Cab Service",
        "WhyChoosedescription": "Meghana Cab offers comfortable and trustworthy cab services from Pune to the serene coastal town of Shrivardhan, perfect for leisure trips and weekend getaways."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop in Shrivardhan",
        "WhyChoosedescription": "We ensure punctual pick-ups from Pune and timely drop-offs at Shrivardhan, so you can enjoy your trip without any travel delays."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Safe and Smooth Travel",
        "WhyChoosedescription": "Our professional drivers are well-versed with the Pune to Shrivardhan route, ensuring a safe, comfortable, and hassle-free journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Meghana Cab provides competitive pricing with no hidden fees, helping you plan your Pune to Shrivardhan travel budget with confidence."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Vehicles",
        "WhyChoosedescription": "Travel in well-maintained, sanitized cabs equipped with safety features like GPS tracking and seat belts for a secure ride."
    },
    {
        "WhyChooseheading": "24/7 Availability for Pune to Shrivardhan Trips",
        "WhyChoosedescription": "Whether it’s an early morning departure or a late-night return, Meghana Cab operates round the clock to meet your Pune to Shrivardhan travel needs."
    },
    {
        "WhyChooseheading": "Flexible Trip Options",
        "WhyChoosedescription": "Choose from one-way, round-trip, or customizable packages tailored to your travel preferences and schedule."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Customer Support",
        "WhyChoosedescription": "Book your Pune to Shrivardhan cab effortlessly through our website or app. Our support team is always available to assist you with bookings and travel queries."
    }
]

























    }





const faqData = [
    {
        question: "How can I book a Pune to Shrivardhan cab with Meghana Cab?",
        answer: "You can book a Pune to Shrivardhan cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What cab options are available for travel from Pune to Shrivardhan?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers for Pune to Shrivardhan trips, depending on your group size and comfort preference."
    },
    {
        question: "Is one-way cab service available from Pune to Shrivardhan?",
        answer: "Yes, we offer both one-way and round-trip cab services from Pune to Shrivardhan."
    },
    {
        question: "How long does it take to travel from Pune to Shrivardhan by cab?",
        answer: "The journey typically takes around 5 hours, covering a distance of approximately 158 kilometers."
    },
    {
        question: "What is the estimated fare for a cab from Pune to Shrivardhan?",
        answer: "The average fare for a one-way trip from Pune to Shrivardhan is around ₹2956, depending on the cab type and other factors."
    },
    {
        question: "Are tolls and taxes included in the cab fare for Pune to Shrivardhan?",
        answer: "Tolls, state taxes, and parking charges are additional and clearly communicated during the booking process."
    },
    {
        question: "Are Meghana Cab drivers experienced for long-distance travel like Pune to Shrivardhan?",
        answer: "Yes, our drivers are professional, experienced, and familiar with long-distance routes including Pune to Shrivardhan."
    },
    {
        question: "Can I request breaks or custom stops during the Pune to Shrivardhan journey?",
        answer: "Yes, you can request halts or breaks during the trip. Please inform us while booking."
    },
    {
        question: "Is the cab service from Pune to Shrivardhan available at night?",
        answer: "Yes, Meghana Cab offers 24/7 service, so you can book a cab for day or night travel as per your convenience."
    },
    {
        question: "What payment options are accepted for Pune to Shrivardhan cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for all bookings."
    },
    {
        question: "How do I contact Meghana Cab to book a Pune to Shrivardhan cab?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Amit Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I booked a cab with Meghana Cab for a trip from Pune to Shrivardhan, and the experience was fantastic. The driver was professional, and the vehicle was comfortable and well-maintained.”',
    },
    {
        name: 'Mrs. Priya Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our family trip to Shrivardhan was made memorable thanks to Meghana Cab. The journey was smooth, and the driver ensured we had a pleasant experience throughout.”',
    },
];












































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];




const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shrivardhan Cab",
  "description": "Enjoy a comfortable and scenic ride from Pune to Shrivardhan with Meghana Cabs. Affordable taxi service for beach trips, weekend getaways, and Konkan tours. Choose from Ertiga, Innova Crysta, and premium cars for a smooth travel experience.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3214"
  }
};










    return (
        <div>
<Helmet>
  <title>Pune to Shrivardhan Cab | Affordable Konkan Beach Taxi @ Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune to Shrivardhan cab with Meghana Cabs for a comfortable beachside journey. Affordable fares, reliable service, and premium cars like Innova Crysta and Ertiga for your Konkan trip."
  />
  <meta
    name="keywords"
    content="pune to shrivardhan cab booking, pune to shrivardhan innova crysta, pune to shrivardhan ertiga car booking, Pune to shrivardhan beach cab, Pune to shrivardhan beach cab fare, pune to shrivardhan beach innova crysta, pune to shrivardhan beach innova cabs, pune to shrivardhan beach ertiga cabs, pune to shrivardhan beach package, pune to shrivardhan beach tour package, pune to harihareshwar cab, pune to harihareshwar cab booking, pune to harihareshwar innova crysta, pune to ganpatipule cabs, pune to konkan innova cab, pune to mahabaleshwar innova rate, pune to konkan darshan cab, pune to sawantwadi cab, pune to ratnagiri cab price"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/65.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshrivardhancab;